$(document).ready(function () {
    "use strict";
    // Preloader (if the #preloader div exists)
    $(window).on('load', function () {
        if ($('#preloader').length) {
            $('#preloader').delay(100).fadeOut('slow', function () {
                $(this).remove();
            });
        }
    });


    // Initiate the wowjs animation library
    new WOW().init();

    // Smooth scroll for the navigation and links with .scrollto classes
    $('.main-nav a, .mobile-nav a, .scrollto').on('click', function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = $(this.hash);
            if (target.length) {
                var top_space = 0;

                $('html, body').animate({
                    scrollTop: target.offset().top - top_space
                }, 1500, 'easeInOutExpo');

                if ($(this).parents('.main-nav, .mobile-nav').length) {
                    $('.main-nav .active, .mobile-nav .active').removeClass('active');
                    $(this).closest('li').addClass('active');
                }

                if ($('body').hasClass('mobile-nav-active')) {
                    $('body').removeClass('mobile-nav-active');
                    $('.mobile-nav-toggle i').toggleClass('fa-times fa-bars');
                    $('.mobile-nav-overly').fadeOut();
                }
                return false;
            }
        }
    });

    // Navigation active state on scroll
    var nav_sections = $('section');
    var main_nav = $('.main-nav, .mobile-nav');
    var main_nav_height = $('#header').outerHeight();

    $(window).on('scroll', function () {
        var cur_pos = $(this).scrollTop();

        nav_sections.each(function () {
            var top = $(this).offset().top - main_nav_height,
                bottom = top + $(this).outerHeight();

            if (cur_pos >= top && cur_pos <= bottom) {
                main_nav.find('li').removeClass('active');
                main_nav.find('a[href="#' + $(this).attr('id') + '"]').parent('li').addClass('active');
            }
        });
    });

    // jQuery counterUp (used in Whu Us section)
    $('[data-toggle="counter-up"]').counterUp({
        delay: 10,
        time: 1000
    });
});


function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).on('scroll', function () {
    $(".home-tiles").each(function () {
        if (isScrolledIntoView($(this))) {
            $(".home-tiles").addClass("home-tiles-view");
        }
    });
    $(".map-img").each(function () {
        if (isScrolledIntoView($(this))) {
            $(".map-img").addClass("map-img-view");
        }
    });
    $(".widget-textbtn").each(function () {
        if (isScrolledIntoView($(this))) {
            $(".widget-textbtn").addClass("widget-textbtn-view");
        }
    });
    $(".quicklinks").each(function () {
        if (isScrolledIntoView($(this))) {
            $(".quicklinks").addClass("quicklinks-view");
        }
    });
    $(".search-widget").each(function () {
        if (isScrolledIntoView($(this))) {
            $(".search-widget").addClass("search-widget-view");
        }
    });
});


$('body :not(script) :not(noscript)').contents().filter(function () {
    return this.nodeType === 3;
}).replaceWith(function () {
    return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
});

$(document).ready(function () {
    $(".quote-img").each(function () {
        var quoteImageSRC = $(this).attr('src');
        var quoteImageFix = quoteImageSRC.slice(1);
        $(this).attr('src', quoteImageFix);
    });
});





$(document).ready(function () {
    if ($('#intro').length > 0) {
        console.log('test');
        $('#top').each(function () {
            $('#top').addClass('banner-adjust');
        });
    }
});

$(document).ready(function () {
    $('.dropdown-custom .drop-down').mouseenter(function (e) {
        $(this).addClass('show');
    }).mouseleave(function (e) {
        $(this).removeClass('show');
    });
    $('.dropdown-custom .drop-down a[data-role="display-value"]').click(function (e) {
        $(this).closest('.drop-down').toggleClass('show');
    });
    $('.dropdown-custom .drop-down a[data-role="select-item"]').click(function (e) {
        $(this).closest('.drop-down').removeClass('show');
    });
});

$(document).ready(function () {
    // Optimize box video responsive dimensions
    $('iframe[src*="app.box.com/embed"]').each(function (i, e) {
        var width = parseInt($(e).attr('width'));
        var height = parseInt($(e).attr('height'));
        $(e).parent('.video-fluid').css('padding-bottom', 'calc(' + (height / width * 100) + '% + 60px)');
    });
});

$(document).ready(function () {
    var productTabs = $('a[data-bs-toggle="tab"]');
    if (productTabs.length) {
        productTabs.on('shown.bs.tab', function() {
            setTimeout(function() {
                $(window).trigger('resize').trigger('scroll');
            }, 500);
        });
        productTabs.on('hidden.bs.tab', function() {
            setTimeout(function() {
                $(window).trigger('resize').trigger('scroll');
            }, 500);
        });
    }
});